import React from 'react';
import { ControllerIcon } from './ControllerIcon';
export function Navbar() {
  return <nav className="fixed top-0 left-0 right-0 z-50 bg-gameu-base/80 backdrop-blur-md border-b border-gameu-card" data-id="element-75">
      <div className="max-w-7xl mx-auto px-6 h-20 flex items-center justify-between" data-id="element-76">
        <div className="flex items-center gap-2" data-id="element-77">
          <ControllerIcon variant="full" className="w-6 h-6 text-gameu-accent" data-id="element-78" />
          <span className="font-serif text-3xl tracking-wide text-gameu-text mt-1" data-id="element-79">
            Gameu
          </span>
        </div>

        <div className="hidden md:flex items-center gap-8 text-sm font-medium text-gameu-muted" data-id="element-80">
          <a href="#problems" className="hover:text-gameu-accent transition-colors" data-id="element-81">
            Problems
          </a>
          <a href="#services" className="hover:text-gameu-accent transition-colors" data-id="element-82">
            Services
          </a>
          <a href="#results" className="hover:text-gameu-accent transition-colors" data-id="element-83">
            Results
          </a>
          <a href="#pricing" className="hover:text-gameu-accent transition-colors" data-id="element-84">
            Pricing
          </a>
          <a href="#team" className="hover:text-gameu-accent transition-colors" data-id="element-85">
            Team
          </a>
        </div>

        <button className="md:hidden text-gameu-text" data-id="element-86">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" data-id="element-87">
            <path d="M4 6h16M4 12h16M4 18h16" strokeLinecap="round" strokeLinejoin="round" data-id="element-88" />
          </svg>
        </button>
      </div>
    </nav>;
}